import {
    changePagedRowsPage,
    failPagedRows,
    initializePagedRows,
    PAGE_FETCH_FAILED_MESSAGE,
    PAGED_ROWS_INITIAL_STATE,
    receivePagedRows,
    reloadPagedRows,
    sortPagedRows
} from "../../../common/pagination/pagedRows";

export const INITIAL_STATE = {
    ...PAGED_ROWS_INITIAL_STATE,
    loadingText: "Loading requests",
    flashBarItem: []
};

export const tableReducerInit = initialState => {
    return initialState;
}

const fetchFailedFlash = dispatcher => [{
    type: "error",
    dismissible: true,
    dismissLabel: "Dismiss message",
    onDismiss: () => dispatcher({type: "DISMISS_FLASHBAR", payload: {}}),
    content: PAGE_FETCH_FAILED_MESSAGE,
    id: "message_1"
}];

// Only updates state: the page fetch each action asks for is made by ExcaliburTable (usePagedRowsFetch).
export const tableReducer = (state, action) => {
    switch (action.type) {
        case "INITIALIZE":
            return initializePagedRows(state);
        case "API_RESPONSE":
            return receivePagedRows(state, action.payload, "transactionId");
        case "PAGE_INDEX_CHANGED":
            return changePagedRowsPage(state, action.payload.pageIndex);
        case "SORTING_CHANGED":
            return sortPagedRows(state, action.payload);
        case "REFRESH":
            return {...reloadPagedRows(state), flashBarItem: []};
        case "AUDIT_FETCH_FAILED": {
            const next = failPagedRows(state, action.payload);
            return next === state ? state : {...next, flashBarItem: fetchFailedFlash(action.payload.dispatcher)};
        }
        case "DISMISS_FLASHBAR":
            return {...state, flashBarItem: []};
        case "FAILURE_API_RESPONSE":
            return {
                ...state,
                loading:false,
                initialize:false,
            }
        default:
            return state;
    }
}
